.root {
  height: 100dvh;
  min-height: 100vh;
  display: flex;
  background: #fff;
}

.left {
  position: sticky;
  top: 0;
  width: 35%;
  min-width: 340px;
  overflow: hidden;
  display: block;
}

@media (max-width: 639.98px) {
  .left {
    display: none;
  }
}

.hero {
  position: absolute;
  inset: 0;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform: translateZ(0);
  filter: saturate(0.95) contrast(0.95) brightness(1.04);
  background-color: var(--tdx-navy);
}

.root[data-client='default'] .hero {
  background-image: url('/images/td-hero.jpg');
}

.root[data-client='mmb'] .hero {
  background-image: url('/images/mymb-hero.jpg');
}

.logoGrid {
  position: absolute;
  bottom: 6.5rem;
  left: 1rem;
  right: 1rem;
}

.logoGroup {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem 1.5rem;
  margin-bottom: 1.25rem;
}
.forMmb {
  display: none;
}
.forDefault {
  display: grid;
}
.root[data-client='mmb'] .forMmb {
  display: grid;
}
.root[data-client='mmb'] .forDefault {
  display: none;
}

.logo {
  display: block;
  width: 100%;
  height: auto;
  max-width: 300px;
}

.leftFooter {
  position: absolute;
  bottom: 1.25rem;
  left: 1rem;
  right: 1rem;

  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem 1.25rem;

  color: #fff;
  font-size: 16px;
  text-align: right;
}
.leftFooter > * {
  white-space: nowrap;
}
.leftFooter a {
  color: #fff;
  text-decoration: underline;
}
.leftFooter .copy {
  color: #fff;
  opacity: 0.95;
}

.right {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
}

.content {
  width: 100%;
  max-width: var(--content-max-width, 350px);
  margin: 0 auto;
  margin-block: auto;
  padding: 24px 16px 40px;
}

.primaryLogo {
  text-align: center;
  margin-bottom: 4em;
}
.primaryLogo img {
  max-width: 260px;
  height: auto;
}

.rightFooter {
  display: none;
  text-align: center;
  margin: 32px 0;
  font-size: 16px;
  text-decoration: none;
}
.rightFooter a,
.rightFooter button {
  color: var(--tdx-navy) !important;
  text-decoration: underline;
}

@media (max-width: 1280px) {
  .logoGroup {
    grid-template-columns: 1fr;
    gap: 1rem;
    justify-items: center;
  }
  .logo {
    max-width: 200px;
  }
}

@media (max-width: 639.98px) {
  .rightFooter {
    display: block;
  }
}

/* ---------- HEADERS ---------- */
:global .naming {
  color: var(--muted);
  font-size: 0.95rem;
  margin: 8px 0 28px;
  text-align: center;
}
:global .pageTitle {
  font-size: 1.5rem;
  line-height: 1.25;
  margin: 0 0 40px;
  text-align: center;
}

/* ---------- LABELS & INPUTS ---------- */
:global label {
  display: block;
  color: var(--muted);
  font-weight: 400;
  font-size: 0.9rem;
  letter-spacing: 0.02em;
  margin: 0 0 6px;
}

:global .form-control {
  display: block;
  width: 100%;
  padding: 6px 0;
  font-size: 1rem;
  color: var(--ink);
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--line);
  border-radius: 0;
  box-shadow: none;
  transition: border-color 0.15s ease-in-out;
}
:global .form-control:hover,
:global .form-control:focus {
  outline: none;
  border-bottom-color: var(--ink);
}
:global .form-control::placeholder {
  color: var(--muted);
}

:global .form-control[disabled],
:global .form-control[readonly] {
  color: #bcbec0;
  border-bottom-color: #efeff0;
}

:global .field-validation-error {
  color: var(--danger) !important;
  font-size: 0.8rem !important;
}

:global .floatField {
  position: relative;
  margin-bottom: 30px;
}

:global .floatInput {
  width: 100%;
  border: 0;
  border-bottom: 1px solid var(--line);
  padding: 8px 0 6px;
  font-size: 14px;
  color: var(--tdx-navy);
  background: transparent;
  outline: none;
  transition: border-color 0.15s ease;
}

:global select.floatInput {
  position: relative;
  z-index: 1;
}

:global .floatInput:focus {
  border-bottom-color: var(--tdx-navy);
}

:global .floatInput[aria-invalid='true'] {
  border-bottom-color: var(--danger);
}

:global .floatLabel {
  position: absolute;
  left: 0;
  top: 0.35em;
  font-size: 1em;
  z-index: 0;
  line-height: 1;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  pointer-events: none;
  transition:
    top 0.15s ease,
    font-size 0.15s ease,
    color 0.15s ease;
}

:global .floatInput:focus + .floatLabel,
:global .floatField.isFilled .floatLabel {
  top: -1.1em !important;
  font-size: 0.8em !important;
  color: var(--tdx-navy);
}

:global .floatInput:-webkit-autofill + .floatLabel,
:global .floatInput:-webkit-autofill:hover + .floatLabel,
:global .floatInput:-webkit-autofill:focus + .floatLabel {
  top: -1.1em !important;
  font-size: 0.8em !important;
  color: var(--tdx-navy);
}

:global .floatInput:-moz-autofill + .floatLabel {
  top: -1.1em !important;
  font-size: 0.8em !important;
  color: var(--tdx-navy);
}
:global .fieldError {
  margin-top: 6px;
  font-size: 12px;
  color: var(--danger);
}

:global .floatInput:-webkit-autofill,
:global .floatInput:-webkit-autofill:hover,
:global .floatInput:-webkit-autofill:focus {
  -webkit-text-fill-color: #0e103e;
  -webkit-box-shadow: 0 0 0px 1000px #fff inset;
  transition: background-color 9999s ease-out 0s;
}

:global .floatInput[readonly],
:global .floatInput:disabled {
  color: var(--muted);
  border-bottom-color: var(--line);
  cursor: not-allowed;
  opacity: 0.7;
}

:global .floatInput[readonly]:not(:placeholder-shown) + .floatLabel,
:global .floatInput:disabled:not(:placeholder-shown) + .floatLabel {
  color: var(--muted);
}

/* ---------- Buttons ---------- */
:global .btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 1em;
  font-size: 1rem;
  text-transform: uppercase;
  text-decoration: none;
  border-radius: 0;
  border: 1px solid transparent;
  transition:
    background-color 0.15s,
    color 0.15s,
    border-color 0.15s;
  cursor: pointer;
}

:global .btn.btn-default {
  color: #fff;
  background-color: var(--btn-primary);
  border-color: var(--btn-primary);
}
:global .btn.btn-default:hover,
:global .btn.btn-default:focus {
  color: var(--btn-primary);
  background: transparent;
  border-color: var(--btn-primary);
}
:global .btn.btn-default:active {
  color: #fff;
  background-color: var(--btn-primary-press);
  border-color: var(--btn-primary-press);
}

:global .btn.btn-default:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  border-color: var(--tdx-gray-500);
  color: var(--tdx-gray-500) !important;
  background: var(--tdx-gray-200);
}

:global .btn.btn-secondary {
  color: #fff;
  background-color: var(--btn-secondary);
  border-color: var(--btn-secondary);
}
:global .btn.btn-secondary:hover,
:global .btn.btn-secondary:focus {
  color: var(--btn-secondary);
  background: transparent;
  border-color: var(--btn-secondary);
}
:global .btn.btn-secondary:active {
  color: #fff;
  background-color: var(--btn-secondary-press);
  border-color: var(--btn-secondary-press);
}

:global .btn.btn-link {
  color: #fff;
  background-color: transparent;
  border: none;
  padding: 0;
  text-transform: none;
  text-decoration: underline;
}

:global .btn.btn-outline {
  appearance: none;
  border: 1px solid var(--tdx-navy);
  background: #fff;
  color: var(--tdx-navy);
}

:global .btn.btn-outline:hover,
:global .btn.btn-outline:active,
:global .btn.btn-outline:focus {
  background: var(--tdx-navy);
  color: #fff !important;
}

:global .btn.btn-outline:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  border-color: var(--tdx-gray-500);
  color: var(--tdx-gray-500) !important;
  background: var(--tdx-gray-200);
}

:global .btn.btn-outline.disabled-link {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
  border-color: var(--tdx-gray-500);
  color: var(--tdx-gray-500) !important;
  background: var(--tdx-gray-200);
}

/* ---------- Links ---------- */
:global .text-link,
:global a.text-link {
  color: var(--ink);
}
:global .text-link:hover {
  text-decoration: underline;
}

:global .afterPrimaryLinks {
  margin: 12px 0 18px;
  text-align: center;
}

:global .muted {
  color: var(--muted);
}

:global hr {
  border: none;
  border-top: 1px solid var(--line);
  margin: 2.5em 0;
}

:global .text-danger {
  color: var(--danger) !important;
}

:global .text-center {
  text-align: center;
}
